import { Checkout } from '@pdqdev/pdq-shared/dist/interfaces';

export interface CheckoutGroupSettings {
  displayRatesOptimization: DisplayOptimisationSettings;
  deliveryMethodSorting: DeliveryMethodSortingSettings;
  nonBusinessDays: NonBusinessDaysSettings;
  categoryBasedShippingConfig?: Checkout.CategoryBasedShippingConfig | null;
}

export interface DisplayOptimisationSettings {
  enableDisplayRatesOptimization?: boolean;
  enableIncreaseRatesPercentage?: boolean;
  increaseRatesPercentage?: number;
  enableSameNameShippingMethodsKeepCheapestOnly?: boolean;
}

export interface DeliveryMethodSortingSettings {
  deliveryMethodSortingMode: string;
  deliveryMethodSortingPriorityMethod?: string[];
}

export type NonBusinessDaysSettings = Checkout.NonBusinessDaysItem[];

export enum DeliverySettingsSortingMethod {
  Cheapest = 'CHEAPEST',
  SecondCheapest = '2ND_CHEAPEST',
  MostExpensiveToLeastExpensive = 'MOST_EXPENSIVE',
  PriorityMethod = 'PRIORITY',
}
